// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + {"63":"lang-hg","265":"lang-hi"}[chunkId] + "." + {"63":"5fa9b9a6","265":"4b520089"}[chunkId] + ".chunk.js");